module.exports = __webpack_public_path__ + "static/media/taimalishan_web.cf3faaad.png";